import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import {
  addNewClientAPI,
  getGeneratedUsernameAPI,
  getUserDataAPI,
  getChildUserInfoAPI,
} from "../service/UserService";
import { EditClientAPI } from "../service/UserService";
import { Encrypt } from "../utils/constants";
import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";


export default function CreateClient() {
  const uid = useParams();
  const [clientData, setClientData] = useState({});
  const location = useLocation();
  const [globalSetting, setGlobalSetting] = useState({});
  const [payload, setPayload] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const userType = useParams()?.usertype;
  const [isCasinoCommission, setIsCasinoCommission] = useState("yes");
  const [isMatkaCommission, setIsMatkaCommission] = useState("yes");
  const [isCommission, setIsCommission] = useState(true);
  const [userId, setUserId] = useState(uid?.id);

  const getUserInfo = async () => {
    const { response } = await getUserDataAPI();
    if (userType?.toUpperCase() == "ADMIN") {
      setIsAdmin(false);
    }
    setClientData(response);
  };

  const getChildUserInfo = async () => {
    const { response } = await getChildUserInfoAPI(userId);

    setClientData(prevState => ({
      ...prevState,
      partnershipAndCommission: {
        ...prevState.partnershipAndCommission,
        casinoCommission: response?.childInfo?.casinoCommission,
        sessionCommission: response?.childInfo?.sessionCommission,
        matchCommission: response?.childInfo?.matchCommission,
        myCasinoPartnership: response?.childInfo?.myCasinoPartnership,
        parentCasinoPartnership: response?.childInfo?.parentCasinoPartnership,
        parentPartnership: response?.childInfo?.parentPartnership,
        myPartnership: response?.childInfo?.myPartnership,
        balance: response?.childInfo?.balance,
        parentLimit: response?.childInfo?.parentLimit,
        commissionOn: response?.childInfo?.commissionOn,
        parentMatchCommission: response?.childInfo?.parentMatchCommission,
        parentCasinoCommission: response?.childInfo?.parentCasinoCommission,
        parentSessionCommission: response?.childInfo?.parentSessionCommission,

      },
      userType: response?.childInfo?.userType,
    }));
    setPayload((prevState) => ({
      ...prevState,
      ...response?.childInfo,
    }));

    console.log(clientData)

    setIsCommission(
      response?.childInfo?.sessionCommission != 0 &&
        response?.childInfo?.matchCommission != 0
        ? "yes"
        : "no"
    );
    setIsCasinoCommission(
      response?.childInfo?.casinoCommission != "0" ? "yes" : "no"
    );
    setIsMatkaCommission(
      response?.childInfo?.matkaCommission != "0" ? "yes" : "no"
    );
  };

  useEffect(() => {
    if (userId) {
      getChildUserInfo();
    }
  }, [userId]);

  const handleSubmit = async () => {
    let filteredPayload = {
      ...payload,
    };
    Object.keys(filteredPayload).forEach((key) => {
      if (
        filteredPayload[key] === location?.state?.client?.[key] ||
        filteredPayload[key] === clientData?.[key]
      ) {
        delete filteredPayload[key];
      }
    });
    try {
      const { response, code, error, status } = await EditClientAPI(
        filteredPayload,
        userId
      );

      if (code === 200) {
        toast.success(response?.status || "User Update Successfully");
        setTimeout(() => {
          window.location.href = `/${clientData?.userType?.toLocaleLowerCase()}`;
        }, 500);
        setPayload({});
      } else if (code === 500) {
        toast.error(response);
      } else if (code !== 200 && status) {
        toast.error(
          status || "Something went wrong Please check all you field"
        );
        setPayload({
          ...payload,
          password: "",
        });
      } else {
        toast.error(
          response || "Something went wrong Please check all you field"
        );
        setPayload({
          ...payload,
          password: "",
        });
      }
    } catch (err) {
      setPayload({});
      toast.error(
        err.message || "Something went wrong Please check all you field"
      );
    }
  };

  const handleCommissionChange = (e) => {
    const commissionOn = e.target.value === "no";
    if (commissionOn) {
      setPayload({
        ...payload,
        matchCommission: 0,
        sessionCommission: 0,
        casinoCommission: 0,
      });
      setIsCommission("no");
    } else {
      setPayload({
        ...payload,
        matchCommission: 2,
        sessionCommission: 3,
        casinoCommission: 0,
      });
      setIsCommission("yes");
    }
  };

  useEffect(() => {
    setClientData({
      partnershipAndCommission: {
        matchCommission: 0,
        sessionCommission: 0,
        casinoCommission: 0
      }
    });
  }, []); // Runs only once on component mount

  useEffect(() => {
    setPayload(location?.state?.client);
  }, []);

  const generatePassword = () => {
    const passwordLength = 6;
    let newPassword = '';
    for (let i = 0; i < passwordLength; i++) {
      newPassword += Math.floor(Math.random() * 10); // Generate a random number between 0 and 9
    }
    setPayload({
      ...payload,
      password: newPassword
    });
  };



  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">

              <h1>Update {clientData?.userType?.toLocaleLowerCase()}</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/super">Super</a>
                </li>
                <li className="breadcrumb-item active">New {clientData?.userType}</li>
              </ol>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
      <section className="content">
        <form action="/master/store" method="POST">
          <input
            type="hidden"
            name="_csrf"
            defaultValue="ba9d3d2b-b2c1-4143-bd84-a7f988415a48"
          />
          <div className="row">
            <div className="col-md-6">
              <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">General</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      data-toggle="tooltip"
                      title="Collapse"
                    >
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="form-group">
                    <label htmlFor="code">Code</label>
                    <input
                      type="text"
                      id="code"
                      placeholder=""
                      readOnly
                      className="form-control"
                      name="code"
                      value={payload?.username}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Name"
                      min={2}
                      defaultValue={payload?.fullName}
                      required=""
                      name="name"
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Reference</label>
                    <input
                      type="text"
                      id="reference"
                      className="form-control"
                      placeholder="Reference"
                      required=""
                      name="reference"
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          reference: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <div className="input-group ">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Password"
                        min={6}
                        id="password"
                        required=""
                        name="password"
                        defaultValue={payload?.password}
                        onChange={(e) =>
                          setPayload({
                            ...payload,
                            password: e.target.value,
                          })
                        }
                      />
                      <span className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-info btn-flat"
                          onClick={generatePassword}
                        >
                          Generate Password
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="mobile">Contact No</label>
                    <input
                      type="number"
                      className="form-control"
                      id="mobile"
                      defaultValue={payload?.mobile}
                      placeholder="Mobile No"
                      required=""
                      name="mobile"
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          mobile: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            <div className="col-md-6 " style={{display : 'none'}}>
              <div className="card card-secondary">
                <div className="card-header">
                  <h3 className="card-title">General</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      data-toggle="tooltip"
                      title="Collapse"
                    >
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="form-group row">
                    <div className="form-group col-md-6">
                      <label htmlFor="share" style={{ textTransform: 'capitalize' }}>
                        {clientData?.userType} Limit</label>
                      <input
                        type="number"
                        min={0}
                        max={
                          clientData?.partnershipAndCommission?.balance
                        }
                        placeholder="Client Limit"
                        className="form-control"
                        id="limit"
                        defaultValue={payload?.balance}
                        step="0.01"
                        required=""
                        name="balance"
                        readOnly
                      // onChange={(e) =>
                      //   setPayload({
                      //     ...payload,
                      //     balance: e.target.value,
                      //   })
                      // }

                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="mshare">My Limit</label>
                      {clientData?.userType?.toUpperCase() == "ADMIN" ? <>
                        <input
                          type="number"
                          placeholder="Limit"
                          className="form-control"
                          value={userData?.balance}
                          id="mlimit"
                          readOnly
                        />
                      </> : <>
                        <input
                          type="number"
                          placeholder="Limit"
                          className="form-control"
                          // value={clientData?.partnershipAndCommission?.balance}
                          id="mlimit"
                          readOnly
                          value={Number(clientData?.partnershipAndCommission?.parentLimit)?.toFixed(2) || 0}
                        />
                      </>}

                    </div>
                  </div>
                  {clientData?.userType?.toLowerCase() !== "client" && (
                    <>
                      <div className="form-group row">
                        <div className="form-group col-md-6">
                          <label htmlFor="share" style={{ textTransform: 'capitalize' }}>{clientData?.userType} Share</label>
                          <input
                            type="number"
                            max={
                              clientData?.partnershipAndCommission?.parentPartnership
                            }
                            min={0.0}
                            name="user[agent_share]"
                            className="form-control"
                            placeholder={`${clientData?.userType} Share`}
                            required="required"
                            step="0.01"
                            // readOnly
                            defaultValue={payload?.myPartnership}
                            onChange={(e) =>
                              setPayload({
                                ...payload,
                                myPartnership: e.target.value,
                              })
                            }
                          // onChange={(e) =>
                          //   setPayload({ ...payload, myPartnership: e.target.value })
                          // }

                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="mshare">My Share</label>
                          <input
                            type="number"
                            placeholder="Share"
                            className="form-control"
                            value={clientData?.partnershipAndCommission
                              ?.parentPartnership}
                            id="mshare"
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="form-group col-md-6">
                          <label htmlFor="share" style={{ textTransform: 'capitalize' }}>{clientData?.userType} Casino Share</label>
                          <input
                            type="number"
                            max={
                              clientData?.partnershipAndCommission
                                ?.parentCasinoPartnership
                            }
                            min={0.0}
                            placeholder="Casino Share"
                            value={payload?.myCasinoPartnership}
                            className="form-control"
                            id="cshare"
                            step="0.01"
                            required=""
                            // readOnly
                            name="cshare"
                            onChange={(e) =>
                              setPayload({
                                ...payload,
                                myCasinoPartnership: e.target.value,
                              })
                            }
                          // onChange={(e) =>
                          //   setPayload({
                          //     ...payload,
                          //     myCasinoPartnership: e.target.value,
                          //   })
                          // }
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="cmshare">My Casino Share</label>
                          <input
                            type="number"
                            placeholder="Share"
                            className="form-control"
                            value={clientData?.partnershipAndCommission?.parentCasinoPartnership}
                            id="cmshare"
                            readOnly
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="form-group">
                    <label htmlFor="commissionOn">Commission Type</label>
                    {/* {clientData?.partnershipAndCommission?.commissionOn} */}
                    <select id="commissionOn" className="form-control"
                      onChange={(e) => {
                        handleCommissionChange(e);
                      }}
                      value={isCommission}
                    // onChange={(e) =>
                    //   setPayload({
                    //     ...payload,
                    //     matchCommission: e.target.value,
                    //   })
                    // }
                    // defaultValue={clientData?.partnershipAndCommission?.commissionOn}
                    // onChange={handleCommissionChange}
                    >
                      <option>Please Select..</option>
                      <option value="no">No Comm</option>
                      <option value="yes">Bet by Bet</option>
                    </select>
                  </div>
                  <div className="form-group row">
                    <div className="form-group col-md-6">
                      <label htmlFor="match_commission">Match Commision</label>
                      <input
                        type="number"
                        className="form-control"
                        step="0.01"
                        id="match_commission"
                        required=""
                        name="matchcommission"
                        max={
                          clientData?.partnershipAndCommission
                            ?.matchCommission
                        }
                        min={0.0}
                        // readOnly
                        defaultValue={payload?.matchCommission}
                        onChange={(e) =>
                          setPayload({
                            ...payload,
                            matchCommission: e.target.value,
                          })
                        }

                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="mc">My Match Commission</label>
                      <input
                        id="mc"
                        type="text"
                        min={0}
                        max={3}
                        value={clientData?.partnershipAndCommission
                          ?.parentMatchCommission}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="form-group col-md-6">
                      <label htmlFor="session_commission">Session Commission</label>
                      <input
                        type="number"
                        className="form-control"
                        step="0.01"
                        id="session_commission"
                        required=""
                        name="sessioncommission"
                        max={
                          clientData?.partnershipAndCommission
                            ?.parentSessionCommission
                        }
                        min={0.0}
                        // readOnly
                        value={payload?.sessionCommission}
                        onChange={(e) =>
                          setPayload({
                            ...payload,
                            sessionCommission: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="mc">My Session Commission</label>
                      <input
                        type="number"
                        value={clientData?.partnershipAndCommission
                          ?.parentSessionCommission}
                        id="sc"
                        className="form-control"
                        placeholder="Session Commission"
                        readOnly
                      />
                    </div>
                  </div>
                  {/* {clientData?.userType?.toLowerCase() !== "client" && ( */}
                    <div className="form-group row">
                      <div className="form-group col-md-6">
                        <label htmlFor="casino_commission">Casino Commission</label>
                        <input
                          type="number"
                          className="form-control"
                          max={
                            clientData?.partnershipAndCommission
                              ?.parentCasinoCommission
                          }
                          min={0.0}
                          id="casino_commission"
                          // readOnly
                          defaultValue={payload?.casinoCommission}
                          name="casinoCommission"
                          onChange={(e) =>
                            setPayload({
                              ...payload,
                              casinoCommission: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label htmlFor="cc">My Casino Commission</label>
                        <input
                          type="number"
                          value={clientData?.partnershipAndCommission
                            ?.parentCasinoCommission}
                          className="form-control"
                          readOnly
                        />
                      </div>
                    </div>
                    {/* )} */}
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <a href="/master" className="btn btn-secondary">
                Cancel
              </a>
              <button type="button" onClick={handleSubmit} className="btn btn-success float-right">
                Update {userType}
              </button>
            </div>
          </div>
        </form>
        <br />
      </section>
    </div>
  )
}
